import { DialogContent as MuiDialogContent } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
export const DialogContentStyled = styled(MuiDialogContent, shouldNotForwardProps('stickyTabs'))(({ stickyTabs }) => ({
    ...(stickyTabs && {
        paddingTop: 0,
    }),
}));
